import "./index.scss";
import React from "react";

function AppButton({
  id = "",
  className = "primary",
  type = "button",
  disabled = false,
  onClick = () => {
    console.log("AppButton Clicked!");
  },
  children,
}) {
  return (
    <button
      id={id}
      className={`AppButton ${className}`}
      type={type}
      disabled={disabled}
      onClick={onClick}>
      {children}
    </button>
  );
}

export default AppButton;
